import gql from 'graphql-tag';

export default gql`
    mutation SaveJobPlannedTrucks($input: SaveJobPlannedTrucksInput!) {
        saveJobPlannedTrucks(input: $input) {
            errors
        }
    }
`;
